import React from 'react';

export const ErrorCross = ({onClick}) => (
    <svg
      className="error_close_forms"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 520 520"
      style={{ enableBackground: "new 0 0 520 520" }}
      xmlSpace="preserve"
      onClick={onClick}
    >
      <path
        d="M342.8,176.3c-4.2-4.2-11-4.2-15.3,0l-68.5,68.5l-68.5-68.5c-4.2-4.2-11-4.2-15.3,0c-4.2,4.2-4.2,11,0,15.3l68.5,68.5
                                   l-68.5,68.5c-4.2,4.2-4.2,11,0,15.3c2.1,2.1,4.9,3.2,7.6,3.2c2.7,0,5.5-1,7.6-3.2l68.5-68.5l68.5,68.5c2.1,2.1,4.9,3.2,7.6,3.2
                                   c2.8,0,5.5-1,7.6-3.2c4.2-4.2,4.2-11,0-15.3l-68.3-68.5l68.5-68.5C347.1,187.4,347.1,180.6,342.8,176.3L342.8,176.3z M342.8,176.3"
      />
    </svg>
  );
  
export  const PasswordEyeOpen = ({ toggle }) => {
    return (
      <svg
        onClick={toggle}
        className="pwd_open_eye"
        version="1.1"
        id="Capa_1"
        x="0px"
        y="0px"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 511.626 511.626"
        style={{ enableBackground: "new 0 0 511.626 511.626" }}
        xmlSpace="preserve"
      >
        <g>
          <path
            d="M505.918,236.117c-26.651-43.587-62.485-78.609-107.497-105.065c-45.015-26.457-92.549-39.687-142.608-39.687
              c-50.059,0-97.595,13.225-142.61,39.687C68.187,157.508,32.355,192.53,5.708,236.117C1.903,242.778,0,249.345,0,255.818
              c0,6.473,1.903,13.04,5.708,19.699c26.647,43.589,62.479,78.614,107.495,105.064c45.015,26.46,92.551,39.68,142.61,39.68
              c50.06,0,97.594-13.176,142.608-39.536c45.012-26.361,80.852-61.432,107.497-105.208c3.806-6.659,5.708-13.223,5.708-19.699
              C511.626,249.345,509.724,242.778,505.918,236.117z M194.568,158.03c17.034-17.034,37.447-25.554,61.242-25.554
              c3.805,0,7.043,1.336,9.709,3.999c2.662,2.664,4,5.901,4,9.707c0,3.809-1.338,7.044-3.994,9.704
              c-2.662,2.667-5.902,3.999-9.708,3.999c-16.368,0-30.362,5.808-41.971,17.416c-11.613,11.615-17.416,25.603-17.416,41.971
              c0,3.811-1.336,7.044-3.999,9.71c-2.667,2.668-5.901,3.999-9.707,3.999c-3.809,0-7.044-1.334-9.71-3.999
              c-2.667-2.666-3.999-5.903-3.999-9.71C169.015,195.482,177.535,175.065,194.568,158.03z M379.867,349.04
              c-38.164,23.12-79.514,34.687-124.054,34.687c-44.539,0-85.889-11.56-124.051-34.687s-69.901-54.2-95.215-93.222
              c28.931-44.921,65.19-78.518,108.777-100.783c-11.61,19.792-17.417,41.207-17.417,64.236c0,35.216,12.517,65.329,37.544,90.362
              s55.151,37.544,90.362,37.544c35.214,0,65.329-12.518,90.362-37.544s37.545-55.146,37.545-90.362
              c0-23.029-5.808-44.447-17.419-64.236c43.585,22.265,79.846,55.865,108.776,100.783C449.767,294.84,418.031,325.913,379.867,349.04
              z"
          />
        </g>
      </svg>
    );
  };
  
export  const PasswordEyeClose = ({ toggle }) => {
    return (
      <svg
        onClick={toggle}
        className="pwd_open_eye"
        version="1.1"
        id="Capa_1"
        x="0px"
        y="0px"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 511.626 511.626"
        style={{ enableBackground: "new 0 0 511.626 511.626" }}
        xmlSpace="preserve"
      >
        <g>
          <g>
            <path
              d="M361.161,291.652c15.037-21.796,22.56-45.922,22.56-72.375c0-7.422-0.76-15.417-2.286-23.984l-79.938,143.321
              C326.235,329.101,346.125,313.438,361.161,291.652z"
            />
            <path
              d="M372.872,94.221c0.191-0.378,0.28-1.235,0.28-2.568c0-3.237-1.522-5.802-4.571-7.715c-0.568-0.38-2.423-1.475-5.568-3.287
              c-3.138-1.805-6.14-3.567-8.989-5.282c-2.854-1.713-5.989-3.472-9.422-5.28c-3.426-1.809-6.375-3.284-8.846-4.427
              c-2.479-1.141-4.189-1.713-5.141-1.713c-3.426,0-6.092,1.525-7.994,4.569l-15.413,27.696c-17.316-3.234-34.451-4.854-51.391-4.854
              c-51.201,0-98.404,12.946-141.613,38.831C70.998,156.08,34.836,191.385,5.711,236.114C1.903,242.019,0,248.586,0,255.819
              c0,7.231,1.903,13.801,5.711,19.698c16.748,26.073,36.592,49.396,59.528,69.949c22.936,20.561,48.011,37.018,75.229,49.396
              c-8.375,14.273-12.562,22.556-12.562,24.842c0,3.425,1.524,6.088,4.57,7.99c23.219,13.329,35.97,19.985,38.256,19.985
              c3.422,0,6.089-1.529,7.992-4.575l13.99-25.406c20.177-35.967,50.248-89.931,90.222-161.878
              C322.908,183.871,352.886,130.005,372.872,94.221z M158.456,362.885C108.97,340.616,68.33,304.93,36.547,255.822
              c28.931-44.921,65.19-78.518,108.777-100.783c-11.61,19.792-17.417,41.206-17.417,64.237c0,20.365,4.661,39.68,13.99,57.955
              c9.327,18.274,22.27,33.4,38.83,45.392L158.456,362.885z M265.525,155.887c-2.662,2.667-5.906,3.999-9.712,3.999
              c-16.368,0-30.361,5.808-41.971,17.416c-11.613,11.615-17.416,25.603-17.416,41.971c0,3.811-1.336,7.044-3.999,9.71
              c-2.668,2.667-5.902,3.999-9.707,3.999c-3.809,0-7.045-1.334-9.71-3.999c-2.667-2.666-3.999-5.903-3.999-9.71
              c0-23.79,8.52-44.206,25.553-61.242c17.034-17.034,37.447-25.553,61.241-25.553c3.806,0,7.043,1.336,9.713,3.999
              c2.662,2.664,3.996,5.901,3.996,9.707C269.515,149.992,268.181,153.228,265.525,155.887z"
            />
            <path
              d="M505.916,236.114c-10.853-18.08-24.603-35.594-41.255-52.534c-16.646-16.939-34.022-31.496-52.105-43.68l-17.987,31.977
              c31.785,21.888,58.625,49.87,80.51,83.939c-23.024,35.782-51.723,65-86.07,87.648c-34.358,22.661-71.712,35.693-112.065,39.115
              l-21.129,37.688c42.257,0,82.18-9.038,119.769-27.121c37.59-18.076,70.668-43.488,99.216-76.225
              c13.322-15.421,23.695-29.219,31.121-41.401c3.806-6.476,5.708-13.046,5.708-19.702
              C511.626,249.157,509.724,242.59,505.916,236.114z"
            />
          </g>
        </g>
      </svg>
    );
  };

  export  const DownArrow = ({ toggle }) => {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 5.75">
        <title>downarrow</title>
        <g id="Layer_2" data-name="Layer 2">
          <g id="Layer_1-2" data-name="Layer 1">
           <path d="M5,5.75H5a.78.78,0,0,1-.53-.21L.22,1.29a.74.74,0,0,1,0-1,.75.75,0,0,1,1,0L5,4,8.74.22a.74.74,0,0,1,1,1L5.51,5.54A.78.78,0,0,1,5,5.75Z"></path>
          </g>
        </g>
      </svg>
    );
  };

  export  const InfoIcon = ({ toggle }) => {
    return (
      <svg viewBox="0 0 512 512">
        <path fill="currentColor" d="M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-36 344h12V232h-12c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h48c6.627 0 12 5.373 12 12v140h12c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12h-72c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12zm36-240c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z">
        </path>
       </svg>
    );
  };

  export const TickIcon = ({onClick}) =>{
    return(
    <svg viewBox="0 0 512 512">
    <g>
    <g>
      <path d="M504.502,75.496c-9.997-9.998-26.205-9.998-36.204,0L161.594,382.203L43.702,264.311c-9.997-9.998-26.205-9.997-36.204,0
        c-9.998,9.997-9.998,26.205,0,36.203l135.994,135.992c9.994,9.997,26.214,9.99,36.204,0L504.502,111.7
        C514.5,101.703,514.499,85.494,504.502,75.496z"/>
    </g>
    </g>
    </svg>
    )
  }

  export const CrossIcon = ({onClick}) =>{
    return(
      <svg
      className={'svg-inline--fa fa-times fa-w-10 fa-2x'}
      viewBox={'0 0 320 512'}
      version="1.1"
    >
      <path d={'M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z'} />
    </svg>
    )
  }

  export const CrossIconForWorkspace = ({onClick}) =>{
    return(
      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 405.2 399.1" space="preserve">
      <g>
          <path d="M337.6,65.2C301.7,29.2,254,9.5,203.2,9.5c-50.8,0-98.5,19.8-134.4,55.7c-35.9,35.9-55.7,83.6-55.7,134.4
              c0,50.8,19.8,98.5,55.7,134.4c35.9,35.9,83.6,55.7,134.4,55.7c50.8,0,98.5-19.8,134.4-55.7c35.9-35.9,55.7-83.6,55.7-134.4
              C393.3,148.8,373.5,101.1,337.6,65.2L337.6,65.2z M322.3,318.7c-31.8,31.8-74.2,49.4-119.1,49.4c-45,0-87.3-17.5-119.1-49.4
              c-65.7-65.7-65.7-172.6,0-238.2c31.8-31.8,74.2-49.4,119.1-49.4c45,0,87.3,17.5,119.1,49.4C388,146.1,388,253,322.3,318.7
              L322.3,318.7z M322.3,318.7"></path>
          <path d="M287,115.8c-4.2-4.2-11-4.2-15.3,0l-68.5,68.5l-68.5-68.5c-4.2-4.2-11-4.2-15.3,0c-4.2,4.2-4.2,11,0,15.3l68.5,68.5
              L119.5,268c-4.2,4.2-4.2,11,0,15.3c2.1,2.1,4.9,3.2,7.6,3.2c2.7,0,5.5-1,7.6-3.2l68.5-68.5l68.5,68.5c2.1,2.1,4.9,3.2,7.6,3.2
              c2.8,0,5.5-1,7.6-3.2c4.2-4.2,4.2-11,0-15.3l-68.3-68.5l68.5-68.5C291.2,126.8,291.2,120,287,115.8L287,115.8z M287,115.8"></path>
      </g>
      </svg>
    )
  }